var _style, _g, _defs, _path, _polygon, _defs2, _path2, _polygon2, _defs3, _path3, _polygon3, _path4, _path5, _polygon4, _line, _line2, _defs4, _polygon5, _defs5, _polygon6, _path6, _path7, _path8, _path9, _defs6, _polygon7, _polygon8, _path10, _defs7, _polygon9, _polygon10, _path11, _g2, _g3, _g4, _g5, _polygon11, _polygon12, _path12, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFryFq40002Vat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#808080;stroke-miterlimit:10;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#CCCCCC;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#808080;}\n\t.st5{clip-path:url(#SVGID_4_);fill:#CCCCCC;}\n\t.st6{clip-path:url(#SVGID_4_);fill:#808080;}\n\t.st7{clip-path:url(#SVGID_6_);fill:#CCCCCC;}\n\t.st8{clip-path:url(#SVGID_6_);fill:#808080;}\n\t.st9{fill:#808080;}\n\t.st10{fill:#CCCCCC;}\n\t.st11{opacity:0.5;fill:url(#SVGID_7_);}\n\t.st12{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#B1B1B1;stroke-miterlimit:10;}\n\t.st14{clip-path:url(#SVGID_9_);}\n\t.st15{clip-path:url(#SVGID_11_);}\n\t.st16{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st17{opacity:0.5;clip-path:url(#SVGID_13_);fill:#808080;}\n\t.st18{clip-path:url(#SVGID_13_);fill:#808080;}\n\t.st19{clip-path:url(#SVGID_13_);fill:#E8AF33;}\n\t.st20{opacity:0.5;clip-path:url(#SVGID_15_);fill:#808080;}\n\t.st21{clip-path:url(#SVGID_15_);fill:#808080;}\n\t.st22{clip-path:url(#SVGID_15_);fill:#E8AF33;}\n\t.st23{opacity:0.25;}\n\t.st24{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:#0AAEFF;}\n\t.st27{fill:#FFFFFF;}\n\t.st28{fill:url(#SVGID_16_);}\n\t.st29{fill:none;stroke:#DB9A00;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st30{display:inline;fill:none;stroke:#DB9A00;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 250,
    cy: 250,
    r: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 250,
    x2: 500,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M119.2,430c2.2,0.5,4.6,0.4,7-0.8c6.6-3.3,10.3-13.2,8.2-22c-1.3-5.7-4.8-9.5-8.8-10.7 c-4-1.2-11-2.9-13.2-3.5c-2.2-0.6-4.6-0.4-7,0.8c-6.6,3.3-10.3,13.2-8.2,22c1.3,5.7,4.8,9.6,8.8,10.7 C109.2,427.3,115.7,429.2,119.2,430z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.4,419.3c-2.1-8.8,1.6-18.7,8.2-22c2.4-1.2,4.8-1.4,7-0.8c-4-1.2-11-2.9-13.2-3.5c-2.2-0.6-4.6-0.4-7,0.8 c-6.6,3.3-10.3,13.2-8.2,22c1.3,5.7,4.8,9.6,8.8,10.7c3.2,0.9,9.7,2.7,13.2,3.5C115.1,428.8,111.7,425,110.4,419.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "89,399.5 118.1,407.6 136.9,400.6 128.3,386.3 89.9,388.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M278.3,473.9c2.2,0.5,4.6,0.4,7-0.8c6.6-3.3,10.3-13.2,8.2-22c-1.3-5.7-4.8-9.5-8.8-10.7 c-4-1.2-11-2.9-13.2-3.5s-4.6-0.4-7,0.8c-6.6,3.3-10.3,13.2-8.2,22c1.3,5.7,4.8,9.6,8.8,10.7 C268.4,471.3,274.8,473.1,278.3,473.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.5,463.2c-2.1-8.8,1.6-18.7,8.2-22c2.4-1.2,4.8-1.4,7-0.8c-4-1.2-11-2.9-13.2-3.5c-2.2-0.6-4.6-0.4-7,0.8 c-6.6,3.3-10.3,13.2-8.2,22c1.3,5.7,4.8,9.6,8.8,10.7c3.2,0.9,9.7,2.7,13.2,3.5C274.3,472.8,270.9,468.9,269.5,463.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "250.7,443.2 279.8,451.3 298.6,444.3 290,430.1 251.6,432.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M389,411.4c2.2,0.5,4.6,0.4,7-0.8c6.6-3.3,10.3-13.2,8.2-22c-1.3-5.7-4.8-9.5-8.8-10.7 c-4-1.2-11-2.9-13.2-3.5c-2.2-0.6-4.6-0.4-7,0.8c-6.6,3.3-10.3,13.2-8.2,22c1.3,5.7,4.8,9.6,8.8,10.7 C379.1,408.8,385.5,410.6,389,411.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.2,400.8c-2.1-8.8,1.6-18.7,8.2-22c2.4-1.2,4.8-1.4,7-0.8c-4-1.2-11-2.9-13.2-3.5c-2.2-0.6-4.6-0.4-7,0.8 c-6.6,3.3-10.3,13.2-8.2,22c1.3,5.7,4.8,9.6,8.8,10.7c3.2,0.9,9.7,2.7,13.2,3.5C385,410.3,381.6,406.5,380.2,400.8z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "363.2,405.1 387.4,392.2 408.9,388.9 400.3,374.7 362,376.7  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M91.8,169.6c-2.2,1.4-3.7,3.6-3.7,6.2v7.9l2.2,0.6v210l191.8,51.4l126.1-72.8V138.8l0-54L216.1,33.2l-17.2,9.9 v64.7L91.8,169.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M216.1,33.2l-17.2,9.9v64.6L91.8,169.6c-2.3,1.3-3.7,3.6-3.7,6.2v7.9l2.2,0.6v210l191.8,51.4l-0.1-211.8 l-2.1,1.2v-7.5c0-2.6,1.4-5,3.7-6.4l107.2-62V94.6l17.4-9.8L216.1,33.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.1689,
    y1: 214.4582,
    x2: 181.4612,
    y2: 243.2466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "282.1,273.9 90.4,220.9 90.4,184.3 279.9,235.1 282.1,233.9  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 186.5,
    y1: 420.2,
    x2: 186.5,
    y2: 210.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 90.4,
    y1: 239.4,
    x2: 282.1,
    y2: 290.8
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_8_",
    points: "129.6,269.6 177.9,282.3 177.9,271.6 129.6,258.9  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "129.6,269.6 135.6,260.5 129.6,258.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_10_",
    points: "195,286.8 243.4,299.5 243.4,288.8 195,276.1  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "195,286.8 201,277.7 195,276.1  "
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M177.9,212.9l-3.6,1.9c-2.1,1.1-3.5,3.3-3.5,5.8v31c0,1.7,1.8,2.9,3.3,2.1l3.7-1.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M101.2,192.3l-3.6,1.9c-2.1,1.1-3.5,3.3-3.5,5.8v31c0,1.7,1.8,2.9,3.3,2.1l3.7-1.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M272.6,238.7l-3.6,1.9c-2.1,1.1-3.5,3.3-3.5,5.8v31c0,1.7,1.8,2.9,3.3,2.1l3.7-1.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M195.8,218l-3.6,1.9c-2.1,1.1-3.5,3.3-3.5,5.8v31c0,1.7,1.8,2.9,3.3,2.1l3.7-1.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_12_",
    points: "287.2,131.5 192.1,186.4 115.9,165.8 211,111  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "211,150.1 248.2,160.1 174,203.8 133.7,194.1  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "211,111 114.8,165.5 114.8,205.6 211,150.1  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M173.6,210.6l107.9-66.8c-2.5,1.7-6.5,0.6-9-2.4s-6.5-4.1-9-2.4c-2.5,1.7-6.5,0.6-9-2.4 c-2.5-3-6.5-4.1-9-2.4c-2.5,1.7-6.5,0.6-9-2.4s-6.5-4.1-9-2.4c-2.5,1.7-6.5,0.6-9-2.4c-2.5-3-6.5-4.1-9-2.4 c-4.1,4.8-10.8,8.7-15.1,8.7c-4.3,0-11,3.9-15.1,8.7c-4.1,4.8-10.8,8.7-15.1,8.7c-4.3,0-11,3.9-15.1,8.7 c-4.1,4.8-10.8,8.7-15.1,8.7s-11,3.9-15.1,8.7c-4.1,4.8-10.8,8.7-15.1,8.7c-4.3,0-11,3.9-15.1,8.7L173.6,210.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_14_",
    points: "378.6,155.9 283.5,210.8 207.3,190.3 302.3,135.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "302.3,174.5 339.6,184.5 265.4,228.3 225.1,218.6  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "302.3,135.5 206.2,190 206.2,230.1 302.3,174.5  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M264.9,235l107.9-66.8c-2.5,1.7-6.5,0.6-9-2.4c-2.5-3-6.5-4.1-9-2.4c-2.5,1.7-6.5,0.6-9-2.4s-6.5-4.1-9-2.4 c-2.5,1.7-6.5,0.6-9-2.4s-6.5-4.1-9-2.4c-2.5,1.7-6.5,0.6-9-2.4s-6.5-4.1-9-2.4c-4.1,4.8-10.8,8.7-15.1,8.7 c-4.3,0-11,3.9-15.1,8.7c-4.1,4.8-10.8,8.7-15.1,8.7c-4.3,0-11,3.9-15.1,8.7c-4.1,4.8-10.8,8.7-15.1,8.7s-11,3.9-15.1,8.7 c-4.1,4.8-10.8,8.7-15.1,8.7c-4.3,0-11,3.9-15.1,8.7L264.9,235z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "282.1,101 222.5,85.1 222.5,63.4 282.1,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "365.7,123.5 306,107.5 306,85.8 365.7,101.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "222.5,85.1 210.5,81.8 210.5,60.1 222.5,63.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "377.6,126.7 365.7,123.5 365.7,101.8 377.6,105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "306,107.5 282.1,101 282.1,79.3 306,85.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    x1: 282.1,
    y1: 90.2,
    x2: 306,
    y2: 96.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "279.6,103.2 219.9,87.3 219.9,65.6 279.6,81.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "363.1,125.6 303.5,109.7 303.5,88 363.1,103.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "219.9,87.3 207.9,84 207.9,62.3 219.9,65.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "375.1,128.9 363.1,125.6 363.1,103.9 375.1,107.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "303.5,109.7 279.6,103.2 279.6,81.5 303.5,88  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 279.6,
    y1: 92.4,
    x2: 303.5,
    y2: 98.9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "107.4,188.9 169.5,205.5 169.5,254.4 107.4,237.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "119.4,203.8 157.5,214.1 157.5,239.4 119.4,229.2  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "202,214.3 264.2,230.9 264.2,279.8 202,263.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "214,229.2 252.1,239.5 252.1,264.8 214,254.6  "
  }))), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "198.9,43.1 390.9,94.6 408.3,84.7 216.1,33.2  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "91.8,169.6 283.6,221.3 390.9,159.3 378.6,155.9 283.5,210.8 207.2,190.3 302.3,135.5 287.2,131.5  192.3,186.4 115.9,165.8 211,111 198.9,107.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.5647,
    y1: 195.6064,
    x2: 184.9003,
    y2: 201.7076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M88.2,175.8c0-2.7,1.3-4.8,3.7-6.2l191.8,51.7c-2.7,1.5-3.7,4-3.7,6.4L88.2,175.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "H",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -154.3,
    y1: 340.4,
    x2: 513.3,
    y2: -45
  })), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 119.1,
    y1: -102,
    x2: 119.1,
    y2: 594.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 275.9,
    y1: -27.2,
    x2: 275.9,
    y2: 669.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 207.9,
    y1: -22.7,
    x2: 207.9,
    y2: 673.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 142.1,
    y1: -34.4,
    x2: 142.1,
    y2: 662.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 135,
    y1: -35.6,
    x2: 135,
    y2: 661
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 197.7,
    y1: -18,
    x2: 197.7,
    y2: 678.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 379.2,
    y1: -40.1,
    x2: 379.2,
    y2: 656.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -48,
    y1: 605.7,
    x2: 619.5,
    y2: 220.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 163.8,
    y1: 460.3,
    x2: 831.4,
    y2: 74.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -98.1,
    y1: 535.8,
    x2: 569.5,
    y2: 150.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -96.4,
    y1: 544.9,
    x2: 571.2,
    y2: 159.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -96.9,
    y1: 524.9,
    x2: 570.7,
    y2: 139.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 364.9,
    y1: -15,
    x2: 364.9,
    y2: 681.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 221.9,
    y1: -27.5,
    x2: 221.9,
    y2: 669.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -201.8,
    y1: 315,
    x2: 465.8,
    y2: -70.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 217.7,
    y1: -40.5,
    x2: 217.7,
    y2: 656.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -137,
    y1: 370.8,
    x2: 530.5,
    y2: -14.6
  })), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 285.7,
    y1: -33.4,
    x2: 285.7,
    y2: 663.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -54.6,
    y1: 415.8,
    x2: 613,
    y2: 30.3
  })), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -663.5,
    y1: -166.9,
    x2: 1176.7,
    y2: 326.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -1000.8,
    y1: 55.7,
    x2: 839.5,
    y2: 548.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -1030.1,
    y1: 68.3,
    x2: 810.1,
    y2: 561.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -801.9,
    y1: -139.2,
    x2: 1038.4,
    y2: 353.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -749.9,
    y1: -59.5,
    x2: 1090.3,
    y2: 433.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -661.3,
    y1: -154.4,
    x2: 1178.9,
    y2: 338.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -767.9,
    y1: -45.7,
    x2: 1072.4,
    y2: 447.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -830.4,
    y1: -114.9,
    x2: 1009.8,
    y2: 378.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 101.8,
    y1: 264,
    x2: 297.6,
    y2: 151.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 360,
    y1: 167.8,
    x2: 145.3,
    y2: 291.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 292.8,
    y1: 143.4,
    x2: 81,
    y2: 265.7
  })), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: -832.5,
    y1: -24.8,
    x2: 1007.7,
    y2: 468.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 274.2,
    y1: -24.8,
    x2: 274.2,
    y2: 671.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFryFq40002Vat);
export default __webpack_public_path__ + "static/media/FRY-FQ-4000-2Vat.1185419b05798b06b83fdfbd72b3cc5f.svg";
export { ForwardRef as ReactComponent };